import { usePresets } from "@/config/color-presets";
import { siteConfig } from "@/config/site.config";
import {
    useApplyColorPreset,
    useColorPresets,
} from "@/layouts/settings/use-theme-color";
import hideRechartsConsoleError from "@/utils/recharts-console-error";
import { Provider } from "jotai";
import { ThemeProvider as NextThemeProvider } from "next-themes";

hideRechartsConsoleError();

export function ThemeProvider({ children }: React.PropsWithChildren) {
    // register the color of the template the defualt is dark
    const COLOR_PRESETS = usePresets();
    const { colorPresets } = useColorPresets();

    useApplyColorPreset<any>(colorPresets ?? COLOR_PRESETS[0].colors);

    return (
        <NextThemeProvider
            enableSystem={false}
            defaultTheme={String(siteConfig.mode)}
        >
            {children}
        </NextThemeProvider>
    );
}

export function JotaiProvider({ children }: React.PropsWithChildren) {
    return <Provider>{children}</Provider>;
}
